var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM13.3333 10.2497V16.3747H14.1667C14.6276 16.3747 15 16.7414 15 17.2251C15 17.7088 14.6268 18.1001 14.1667 18.1001H10.8333C10.3732 18.1001 10 17.7088 10 17.2251C10 16.7414 10.3732 16.3501 10.8333 16.3501H11.6667V11.1001H10.8333C10.3732 11.1001 10 10.7334 10 10.2497C10 9.76601 10.3732 9.37472 10.8333 9.37472H12.5C12.9602 9.37472 13.3333 9.76601 13.3333 10.2497ZM13.75 6.31223C13.75 7.03711 13.1904 7.62473 12.5 7.62473C11.8096 7.62473 11.25 7.03738 11.25 6.3125C11.25 5.58762 11.8099 5 12.5 5C13.1901 5 13.75 5.58735 13.75 6.31223Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4a952b4af2e7d3bb04bdac4e9e744a49.svg";
export { ForwardRef as ReactComponent };